import {
  type CfopEntradaPersonalizada,
  type ClassificacaoPersonalizada,
  type GrupoPersonalizada,
} from '@fiscoai/contracts';

import { itens } from '../regras/textos';

/** Grupo contábil por extenso: "grupo Custo", "grupo pelo centro de custo". */
export const GRUPO: Record<
  GrupoPersonalizada,
  { opcao: string; frase: string; descricao: string }
> = {
  ATIVO: { opcao: 'Ativo', frase: 'Ativo', descricao: 'Sempre no ativo' },
  CUSTO: { opcao: 'Custo', frase: 'Custo', descricao: 'Sempre no custo' },
  DESPESA: { opcao: 'Despesa', frase: 'Despesa', descricao: 'Sempre na despesa' },
  CENTRO_CUSTO: {
    opcao: 'Pelo centro de custo',
    frase: 'pelo centro de custo',
    descricao: 'Natureza do CC do item',
  },
};

export const GRUPOS = Object.keys(GRUPO) as GrupoPersonalizada[];

/** "949" → "x949": o 1º dígito vem da UF do fornecedor (1 mesma UF, 2 outra). */
export const finalComX = (final: string) => `x${final}`;

/** Só os 3 dígitos do final ("x949", "2.949" e "949" viram "949"); fora disso, o que sobrou. */
export function limparFinal(texto: string): string {
  const d = texto.replace(/\D/g, '');
  return d.length > 3 ? d.slice(-3) : d;
}

/** As peças da frase do CFOP de entrada (o componente destaca os valores). */
export function pecasCfop(cfop: CfopEntradaPersonalizada) {
  return cfop.tipo === 'MESMO'
    ? { tipo: 'MESMO' as const }
    : { tipo: 'FINAL' as const, final: finalComX(cfop.final), cfops: cfop.cfopsFornecedor };
}

/** "Usada em 12 itens e 1 regra" / "Ainda não usada". */
export function uso(c: Pick<ClassificacaoPersonalizada, 'itens' | 'regras'>): string {
  const partes = [
    ...(c.itens > 0 ? [itens(c.itens)] : []),
    ...(c.regras > 0 ? [`${String(c.regras)} ${c.regras === 1 ? 'regra' : 'regras'}`] : []),
  ];
  return partes.length === 0 ? 'Ainda não usada' : `Usada em ${partes.join(' e ')}`;
}

/** Sugestão de preenchimento do estado vazio (só texto de exemplo, nada da empresa). */
export const EXEMPLO = {
  nome: 'Revenda de crédito pré-pago',
  final: '949',
  cfopsFornecedor: ['5949', '6949'],
} as const;
